import { createFileRoute } from "@tanstack/react-router";

import AddAccount1 from "@/features/onboarding/AddAccount1";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-account-1")({
  component: () => (
    <BasicLayout>
      <AddAccount1 />
    </BasicLayout>
  ),
});
